module.exports = __webpack_public_path__ + "img/244.3c3e600e.jpg";